import { render, staticRenderFns } from "./certification-item.vue?vue&type=template&id=3459d5f2&scoped=true"
import script from "./certification-item.vue?vue&type=script&lang=js"
export * from "./certification-item.vue?vue&type=script&lang=js"
import style0 from "./certification-item.vue?vue&type=style&index=0&id=3459d5f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459d5f2",
  null
  
)

export default component.exports